import { render, staticRenderFns } from "./issueMg.vue?vue&type=template&id=753bd2da&scoped=true"
import script from "./issueMg.vue?vue&type=script&lang=js"
export * from "./issueMg.vue?vue&type=script&lang=js"
import style0 from "./issueMg.vue?vue&type=style&index=0&id=753bd2da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753bd2da",
  null
  
)

export default component.exports